import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
import { type SubjectDetailResponse } from '@mc/educator-api'
import { retryExcept404 } from '../../utils/queryRetry'
import { liveLessonApi } from './liveLessonApi'

interface UseSubjectDetailOptions {
  subjectSlug: string
  initialData?: SubjectDetailResponse
  enabled?: boolean
  queryOptions?: Omit<
    UseQueryOptions<SubjectDetailResponse>,
    'queryKey' | 'queryFn'
  >
}

export const subjectDetailQueryKey = (subjectSlug: string) => [
  'subject-detail',
  subjectSlug,
]

export const fetchSubjectDetail = (subjectSlug: string) =>
  liveLessonApi.getSubjectDetail({ subjectSlug })

export const useSubjectDetail = ({
  subjectSlug,
  initialData,
  enabled = true,
  queryOptions,
}: UseSubjectDetailOptions) =>
  useQuery<SubjectDetailResponse>(
    subjectDetailQueryKey(subjectSlug),
    () => fetchSubjectDetail(subjectSlug),
    {
      initialData,
      enabled: enabled && !!subjectSlug,
      staleTime: 1 * 60 * 1000,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      retry: retryExcept404,
      ...queryOptions,
    },
  )
